import React, { useState, useEffect } from "react"
import { Grid } from '@mui/material'
import { Container } from '@mui/material'
import GroupCard from "../components/GroupCard"
import makeStyles from "@mui/styles/makeStyles"
import LinearProgress from '@mui/material/LinearProgress'
import groupsProvider from "../providers/GroupsProvider"
import Group from "../models/Group"
import Modal from "../includes/Modal"
import { Box, Typography } from '@mui/material'

const useStyles = makeStyles({
    pageGroup: {
        marginBottom: "35px",
        opacity: 1,
        backgroundColor: 'transparent'
    }
})

export default function Groups(props) {
    const classes = useStyles()
    const [groups, setGroups] = useState([])
    var [groupCounter, setGroupCounter] = useState(1)
    const [isLoading, setIsLoading] = useState(true)
    const [groupCommands, setGroupCommands] = useState([])
    const [modalOpen, setModalOpen] = useState(false)
    const [modalMessage, setModalMessage] = useState("")

    const handleUpdate = async (group) => {
        await fetch(`${process.env.REACT_APP_URL}/group/update/location`, {
            method: 'POST',
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + props.token
            },
            body: JSON.stringify({
                "value": group.vL_CADASTRO,
                "local": group.dS_LOCALIZACAO
            })
        });
        
        let groupInstances = groups.map(groupData => new Group(groupData));

        groupInstances.forEach(newGroup => {
            if (newGroup.position === group.vL_CADASTRO) {
                newGroup.local = group.dS_LOCALIZACAO;
            }
        });

        groupsProvider.updateGroupsList(groupInstances);
        return true;
    }

    const orderGroups = (a, b) => {    
        const numA = parseInt(a.vL_CADASTRO.slice(12));
        const numB = parseInt(b.vL_CADASTRO.slice(12));
        return numA - numB;
    }

    const getRegistersBySerial = async (serialNumber) => {
        try 
        {
            const response = await fetch(`${process.env.REACT_APP_URL}/register/all`, {
                method: 'POST',
                headers: {
                    "content-type": "application/json",
                    "Authorization": "Bearer " + props.token
                },
                body: JSON.stringify({ serialNumber })
            });

            return await response.json();
        }
        catch (e)
        {
            console.log("🚀 ~ getRegistersBySerial ~ e:", e)       
        }
    }

    const getGroupsData = async () => {
        try
        {
            const response = await fetch(`${process.env.REACT_APP_URL}/group/all`, {
                method: 'POST',
                headers: {
                    "content-type": "application/json",
                    "Authorization": "Bearer " + props.token
                },
                body: JSON.stringify({ "serialNumber": props.serial })
            });

            if (!response.ok)
            {
                throw new Error("Não foi possível obter os dados de grupos");
            }

            const res = await response.json();

            if (!!res)
            {
                if (!!sessionStorage.getItem('amplifiers'))
                {
                    setTimeout(async () => {
                        let workData = res;
                        let controlAmplifiers = JSON.parse(sessionStorage.getItem('amplifiers'));
                        let controlRegisters = await getRegistersBySerial(res[0].fK_CENTRAL_GRUPO);
                        
                        workData.forEach(group => {
                            group.amplifier = controlAmplifiers.all.filter(a => a.fK_VL_CADASTR_GRUPO === group.vL_CADASTRO);
                            group.register.forEach(r => {
                                controlRegisters.forEach(control => {
                                    if (r.dS_NUM_SERIE === control.dS_NUM_SERIE)
                                    {
                                        r.dS_LOCALIZACAO_EXT = control.dS_LOCALIZACAO;
                                    }
                                });
                            });
                        });
    
                        setGroups(workData.sort(orderGroups));
                        setIsLoading(false);
                    }, 1000);
                }
                else
                {
                    console.log("🚀 ~ getGroupsData ~ e", "Não foi possível obter os dados de amplificadores, nova tentativa!");
                    getGroupsData();
                }
            }
        }
        catch (e)
        {
            console.log("🚀 ~ getGroupsData ~ e:", e)
        }
        finally
        {
        }
    }

    useEffect(() => {
        getGroupsData();
    }, []);

    useEffect(() => {
        console.log("🚀 ~ useEffect ~ props.groupCommands:", props.groupCommands)
        setGroupCommands(props.groupCommands)
        console.log("useEffect ~ command", groupCommands.find(item => item.groupValue === groups[1].vL_CADASTRO) || groupCommands.find(item => item.groupValue === 'general'));
    }, [props.groupCommands])

    return (
        <main class="container" style={{ paddingTop: '1.5rem', paddingBottom: '2rem' }}>

            <Box sx={{ 
                bgcolor: 'transparent',
                borderBottom: '1px solid rgba(224, 224, 224, 0.3)',
                borderRadius: '0',
                padding: '8px 0',
                marginBottom: '2rem',
                boxShadow: 'none',
                textAlign: 'center',
                cursor: 'default',
                pointerEvents: 'none',
                userSelect: 'none'
            }}>
                <Typography 
                    variant="h5" 
                    component="h3" 
                    sx={{ 
                        fontWeight: 400,
                        color: 'text.secondary',
                        letterSpacing: '0.5px',
                        textTransform: 'uppercase',
                        fontSize: '0.95rem'
                    }}
                >
                    Grupos Registrados no Sistema
                </Typography>
            </Box>

            {isLoading && 
                <LinearProgress color="secondary" style={{position: "fixed", top: "0", left: "0", width: "100%", zIndex: "1201", height: "4px"}} /> 
            }
            <div className="grid" data-grid-xl-columns="3" data-grid-md-columns="2" data-grid-xs-columns="1" style={{opacity: 1, backgroundColor: 'transparent'}}>
            {groups.map((group,index) => (
                <div key={group.vL_CADASTRO} class="grid__item grid__item--no-grow mb-5" style={{opacity: 1}}>
                    <GroupCard
                        command={groupCommands.find(item => item.groupValue === group.vL_CADASTRO) || groupCommands.find(item => item.groupValue === 'general')} 
                        rows={props.rows} 
                        role={props.role} 
                        token={props.token} 
                        group={group} 
                        groupIndex={index}
                        handleUpdate={handleUpdate} 
                        length={groups.length} 
                        counter={groupCounter++} 
                    />
                </div>
            ))}
            </div>

            <Modal modalId="modal-alert-group" open={modalOpen}>
                <Modal.Header>
                    <h5 className="modal__title">Atenção</h5>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center px-2">
                        <p>{modalMessage}</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="buttons-container buttons-container--center mb-3 px-5">
                        <button
                            type="button"
                            className="button button--primary button--sm"
                            onClick={() => setModalOpen(false)}
                        >
                            <span className="button__label">
                                Ok
                            </span>
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </main>
    )
}